import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { TreeDeciduous, ArrowLeft, Mail } from 'lucide-react';

const AGBPage = () => {
  const { t, language } = useLanguage();

  const content = {
    de: {
      title: 'Allgemeine Geschäftsbedingungen',
      sections: [
        {
          title: '1. Geltungsbereich',
          content: 'Diese Allgemeinen Geschäftsbedingungen gelten für alle Nutzer der Plattform ForestHub. Mit der Registrierung erkennen Sie diese Bedingungen an.'
        },
        {
          title: '2. Leistungsbeschreibung',
          content: 'ForestHub ist eine Vermittlungsplattform, die Waldbesitzer mit Forstdienstleistern verbindet. Wir stellen lediglich die technische Infrastruktur bereit.'
        },
        {
          title: '3. Nutzerpflichten',
          content: 'Nutzer verpflichten sich, wahrheitsgemäße Angaben zu machen und keine rechtswidrigen Inhalte zu veröffentlichen.'
        },
        {
          title: '4. Haftung',
          content: 'ForestHub haftet nicht für die Qualität der vermittelten Dienstleistungen. Die Vertragsbeziehung besteht ausschließlich zwischen Waldbesitzer und Dienstleister.'
        },
        {
          title: '5. Kündigung',
          content: 'Nutzer können ihr Konto jederzeit löschen. Bereits abgeschlossene Projekte bleiben hiervon unberührt.'
        }
      ]
    },
    en: {
      title: 'Terms and Conditions',
      sections: [
        {
          title: '1. Scope',
          content: 'These Terms and Conditions apply to all users of the ForestHub platform. By registering, you accept these terms.'
        },
        {
          title: '2. Service Description',
          content: 'ForestHub is a brokerage platform that connects forest owners with forestry contractors. We only provide the technical infrastructure.'
        },
        {
          title: '3. User Obligations',
          content: 'Users agree to provide truthful information and not to publish any unlawful content.'
        },
        {
          title: '4. Liability',
          content: 'ForestHub is not liable for the quality of the brokered services. The contractual relationship exists exclusively between the forest owner and the contractor.'
        },
        {
          title: '5. Termination',
          content: 'Users can delete their account at any time. Already completed projects remain unaffected.'
        }
      ]
    },
    se: {
      title: 'Allmänna villkor',
      sections: [
        {
          title: '1. Tillämpningsområde',
          content: 'Dessa allmänna villkor gäller för alla användare av ForestHub-plattformen. Genom att registrera dig accepterar du dessa villkor.'
        },
        {
          title: '2. Tjänstebeskrivning',
          content: 'ForestHub är en förmedlingsplattform som kopplar samman skogsägare med skogsentreprenörer. Vi tillhandahåller endast den tekniska infrastrukturen.'
        },
        {
          title: '3. Användarförpliktelser',
          content: 'Användare förbinder sig att lämna sanningsenliga uppgifter och att inte publicera olagligt innehåll.'
        },
        {
          title: '4. Ansvar',
          content: 'ForestHub ansvarar inte för kvaliteten på de förmedlade tjänsterna. Avtalsförhållandet finns uteslutande mellan skogsägaren och entreprenören.'
        },
        {
          title: '5. Uppsägning',
          content: 'Användare kan radera sitt konto när som helst. Redan avslutade projekt påverkas inte.'
        }
      ]
    }
  };

  const c = content[language] || content.de;

  return (
    <div className="min-h-screen bg-warm-50">
      <header className="bg-white border-b border-warm-200">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <Link to="/" className="flex items-center gap-2">
            <div className="p-2 rounded-lg bg-primary">
              <TreeDeciduous className="h-5 w-5 text-white" />
            </div>
            <span className="font-serif text-xl font-bold text-primary">ForestHub</span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-primary hover:underline mb-8">
          <ArrowLeft className="h-4 w-4" />
          {t('common.back')}
        </Link>

        <h1 className="font-serif text-3xl font-bold text-gray-900 mb-8">{c.title}</h1>

        <div className="space-y-8">
          {c.sections.map((section, index) => (
            <div key={index}>
              <h2 className="font-semibold text-xl text-gray-900 mb-3">{section.title}</h2>
              <p className="text-gray-600">{section.content}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 bg-primary/5 rounded-xl border border-primary/20">
          <p className="text-sm text-gray-600 mb-2">
            {language === 'en' && 'Questions about the terms?'}
            {language === 'se' && 'Frågor om villkoren?'}
            {(!language || language === 'de') && 'Fragen zu den AGB?'}
          </p>
          <a href="mailto:info@hodema.se" className="flex items-center gap-2 text-primary hover:underline">
            <Mail className="h-4 w-4" />
            info@hodema.se
          </a>
        </div>
      </main>
    </div>
  );
};

export default AGBPage;
